module.exports = __webpack_public_path__ + "static/plastfritt-seo-img-4b21d6c34c9bb6c1ce3485b360610e93.png";